import { render, staticRenderFns } from "./project-sort-button.vue?vue&type=template&id=30fafaea&scoped=true&"
import script from "./project-sort-button.vue?vue&type=script&lang=ts&"
export * from "./project-sort-button.vue?vue&type=script&lang=ts&"
import style0 from "./project-sort-button.vue?vue&type=style&index=0&id=30fafaea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fafaea",
  null
  
)

export default component.exports